import React from "react";
import { Row, Col, Container } from "react-bootstrap";

// Self-contained Finance-style shimmer for the Student Permission module.
const css = `
@keyframes permShimmer { 0% { background-position: -800px 0; } 100% { background-position: 800px 0; } }
.perm-shim { background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 800px 100%; animation: permShimmer 1.4s infinite linear; border-radius: 6px; }
`;

const S = ({ width = "100%", height = 14, radius = 6, style = {} }) => (
    <div className="perm-shim" style={{ width, height, borderRadius: radius, ...style }} />
);

const COLS = [120, 80, 120, 110, 80, 80, 90, 90, 80];

export const StudentPermissionShimmer = () => (
    <div style={{ background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)", minHeight: "100vh", padding: "24px 28px", marginBottom: 100 }}>
        <style>{css}</style>
        <Container fluid className="px-0">
            <div style={{ background: "#fff", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", border: "1px solid #e2e8f0", overflow: "hidden" }}>
                {/* Header */}
                <div style={{ padding: "20px 24px", display: "flex", alignItems: "center", gap: 14, borderBottom: "1px solid #f1f5f9" }}>
                    <S width={38} height={38} radius={10} style={{ flexShrink: 0 }} />
                    <div style={{ flex: 1 }}>
                        <S width={180} height={15} style={{ marginBottom: 8 }} />
                        <S width={250} height={10} />
                    </div>
                    <S width={150} height={40} radius={9} style={{ flexShrink: 0 }} />
                    <S width={130} height={40} radius={9} style={{ flexShrink: 0 }} />
                </div>
                {/* Filters */}
                <div style={{ padding: "16px 24px", borderBottom: "1px solid #f3f4f6" }}>
                    <Row className="g-2">
                        {[0, 1, 2, 3].map((i) => (
                            <Col xl={3} lg={3} md={6} sm={12} key={i} className="mb-2">
                                <S width="55%" height={11} style={{ marginBottom: 7 }} />
                                <S width="100%" height={42} radius={9} />
                            </Col>
                        ))}
                    </Row>
                </div>
                {/* Status cards + table */}
                <div style={{ padding: "20px 24px" }}>
                    <Row className="mb-3">
                        {[0, 1, 2].map((i) => (
                            <Col xl={4} lg={4} md={4} sm={12} key={i} className="mb-2">
                                <S width="100%" height={84} radius={14} />
                            </Col>
                        ))}
                    </Row>
                    <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 14, padding: "16px 20px" }}>
                        <div style={{ display: "flex", gap: 16, padding: "10px 0", borderBottom: "2px solid #f3f4f6", marginBottom: 4 }}>
                            {COLS.map((w, i) => <S key={i} width={w} height={13} style={{ flexShrink: 0 }} />)}
                        </div>
                        {Array.from({ length: 6 }).map((_, r) => (
                            <div key={r} style={{ display: "flex", gap: 16, padding: "14px 0", borderBottom: "1px solid #f3f4f6", alignItems: "center" }}>
                                {COLS.map((w, i) => <S key={i} width={w} height={12} style={{ flexShrink: 0 }} />)}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </Container>
    </div>
);

export default StudentPermissionShimmer;
